/* Wobbl theme */
(() => {
  const T = window.theme || {};
  const R = T.routes || { cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' };
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];
  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (m) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]));
  const design = !!(window.Shopify && window.Shopify.designMode);

  /* ---------- money ---------- */
  function money(cents) {
    const c = Number(cents) || 0;
    const fmt = (d, ts, ds) => {
      const p = (c / 100).toFixed(d).split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts);
      return p.join(ds);
    };
    const f = T.moneyFormat || '€{{amount_with_comma_separator}}';
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => ({
      amount: fmt(2, ',', '.'),
      amount_no_decimals: fmt(0, ',', '.'),
      amount_with_comma_separator: fmt(2, '.', ','),
      amount_no_decimals_with_comma_separator: fmt(0, '.', ','),
      amount_with_apostrophe_separator: fmt(2, "'", '.'),
      amount_with_space_separator: fmt(2, ' ', ',')
    }[k] || fmt(2, '.', ',')));
  }
  window.wobblMoney = money;

  /* ---------- toast ---------- */
  let tt;
  function toast(t) {
    const el = $('#toast'); if (!el) return;
    $('#toastT').textContent = t; el.classList.add('show');
    clearTimeout(tt); tt = setTimeout(() => el.classList.remove('show'), 2800);
  }

  /* ---------- scrolling ---------- */
  let lenis = null;
  function go(target) {
    const t = typeof target === 'string' ? $(target) : target;
    if (!t) return;
    if (lenis) lenis.scrollTo(t, { offset: -90, duration: 1.4 });
    else window.scrollTo({ top: t.getBoundingClientRect().top + window.scrollY - 90, behavior: 'smooth' });
  }
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a[href^="#"]');
    if (!a) return;
    const h = a.getAttribute('href');
    if (h.length > 1 && $(h)) { e.preventDefault(); closeCart(); closeMenu(); go(h); }
  });

  /* ---------- mobile menu ---------- */
  function closeMenu() { const m = $('#MobileNav'); if (m) { m.classList.remove('open'); m.setAttribute('aria-hidden', 'true'); } }
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-menu-open]')) { const m = $('#MobileNav'); if (m) { m.classList.add('open'); m.setAttribute('aria-hidden', 'false'); } }
    if (e.target.closest('[data-menu-close]')) closeMenu();
  });

  /* ---------- cart drawer ---------- */
  const drawer = $('#CartDrawer'), scrim = $('#CartScrim');
  function openCart() {
    if (!drawer) { window.location.href = R.cart; return; }
    drawer.classList.add('open'); scrim && scrim.classList.add('open'); drawer.setAttribute('aria-hidden', 'false');
    const c = $('[data-close-cart]', drawer); c && c.focus({ preventScroll: true });
  }
  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove('open'); scrim && scrim.classList.remove('open'); drawer.setAttribute('aria-hidden', 'true');
  }
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-open-cart]') && drawer && !document.body.classList.contains('template-cart')) { e.preventDefault(); refreshCart().then(openCart); }
    if (e.target.closest('[data-close-cart]') || e.target === scrim) closeCart();
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') { closeCart(); closeMenu(); } });

  async function getCart() {
    const r = await fetch(R.cart + '.js', { headers: { Accept: 'application/json' } });
    return r.json();
  }
  function img(url, w) { if (!url) return ''; return url + (url.includes('?') ? '&' : '?') + 'width=' + w; }
  function renderCart(cart) {
    $$('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; el.classList.add('bump'); setTimeout(() => el.classList.remove('bump'), 300); });
    if (!drawer) return;
    $('[data-cart-subtotal]', drawer).textContent = money(cart.total_price);
    const free = Number(T.freeShipping) || 0, txt = $('[data-free-text]', drawer), bar = $('[data-free-bar]', drawer);
    if (free > 0 && txt) {
      const left = free - cart.total_price;
      txt.innerHTML = left > 0 ? `Nog <b>${money(left)}</b> tot gratis verzending` : '<b>Je hebt gratis verzending</b>';
      bar.style.width = Math.min(100, (cart.total_price / free) * 100) + '%';
    }
    const lines = $('[data-cart-lines]', drawer);
    lines.innerHTML = cart.items.length ? cart.items.map((it) => `
      <div class="line">
        <a class="im" href="${esc(it.url)}">${it.image ? `<img src="${esc(img(it.image, 200))}" alt="" loading="lazy">` : ''}</a>
        <div>
          <a href="${esc(it.url)}"><b>${esc(it.product_title)}</b></a>
          ${it.variant_title && it.variant_title !== 'Default Title' ? `<small>${esc(it.variant_title)}</small>` : ''}
          <div class="q">
            <button type="button" data-line="${esc(it.key)}" data-q="${it.quantity - 1}" aria-label="Minder">−</button>
            <span>${it.quantity}</span>
            <button type="button" data-line="${esc(it.key)}" data-q="${it.quantity + 1}" aria-label="Meer">+</button>
            <button type="button" class="rm" data-line="${esc(it.key)}" data-q="0">Verwijder</button>
          </div>
        </div>
        <div class="lp">${money(it.final_line_price)}</div>
      </div>`).join('')
      : `<div class="empty"><b>Je mand is nog leeg</b><span>Tijd voor iets zachts.</span><a class="btn btn-black" href="${esc(R.root || '/')}collections/all">Verder winkelen</a></div>`;
    const co = $('[data-checkout]', drawer);
    if (co) co.toggleAttribute('disabled', !cart.items.length);
  }
  async function refreshCart() { try { renderCart(await getCart()); } catch (e) {} }
  if (drawer) {
    drawer.addEventListener('click', async (e) => {
      const b = e.target.closest('[data-line]'); if (!b) return;
      drawer.classList.add('loading');
      try {
        const r = await fetch(R.cartChange + '.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: b.dataset.line, quantity: Number(b.dataset.q) })
        });
        const c = await r.json();
        if (r.ok) renderCart(c); else toast(c.description || 'Dat lukte niet, probeer het opnieuw.');
      } catch (err) { toast('Geen verbinding, probeer het opnieuw.'); }
      drawer.classList.remove('loading');
    });
  }

  /* ---------- product forms ---------- */
  const norm = (s) => String(s || '').trim().toLowerCase();
  function initProduct(root) {
    const jsonEl = $('[data-product-json]', root); if (!jsonEl) return;
    const data = JSON.parse(jsonEl.textContent);
    const form = $('form[data-product-form]', root); if (!form) return;
    const idInput = $('input[name="id"]', form);
    let cur = data.variants.find((v) => String(v.id) === idInput.value) || data.variants[0];
    const sel = [...cur.options];
    const names = (data.options || []).map((o) => norm(typeof o === 'string' ? o : o.name));
    const btn = $('[data-add]', root), btnLbl = $('[data-add-label]', root);
    const priceEl = $('[data-price]', root), wasEl = $('[data-was]', root), saveEl = $('[data-save]', root), stock = $('[data-stock]', root);
    const mainImg = $('[data-main-img]', root);

    function find(s) { return data.variants.find((v) => v.options.every((o, i) => o === s[i])); }
    function update(fromUser) {
      $$('[data-opt]', root).forEach((b) => {
        const i = +b.dataset.opt, on = b.dataset.value === sel[i];
        b.setAttribute(b.classList.contains('pack') ? 'aria-checked' : 'aria-pressed', String(on));
        const test = [...sel]; test[i] = b.dataset.value;
        const v = find(test);
        b.classList.toggle('na', !v || !v.available);
      });
      $$('[data-opt-label]', root).forEach((l) => { l.textContent = sel[+l.dataset.optLabel] || ''; });
      const v = find(sel);
      if (!v) { btn.disabled = true; btnLbl.textContent = 'Niet beschikbaar'; return; }
      cur = v; idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      const hasWas = v.compare_at_price && v.compare_at_price > v.price;
      if (wasEl) { wasEl.hidden = !hasWas; wasEl.textContent = hasWas ? money(v.compare_at_price) : ''; }
      if (saveEl) { saveEl.hidden = !hasWas; saveEl.textContent = hasWas ? 'Bespaar ' + money(v.compare_at_price - v.price) : ''; }
      btn.disabled = !v.available;
      btnLbl.textContent = v.available ? (btn.dataset.text || 'In winkelmand') : 'Uitverkocht';
      if (stock) { stock.classList.toggle('out', !v.available); $('span', stock).textContent = v.available ? stock.dataset.in : 'Tijdelijk uitverkocht'; }
      if (fromUser && v.featured_media && mainImg) {
        const t = $(`[data-thumb][data-media-id="${v.featured_media.id}"]`, root);
        if (t) t.click();
      }
      if (fromUser && root.dataset.updateUrl === 'true') {
        const u = new URL(window.location.href); u.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', u.toString());
      }
    }
    root.addEventListener('click', (e) => {
      const b = e.target.closest('[data-opt]');
      if (b) { e.preventDefault(); sel[+b.dataset.opt] = b.dataset.value; update(true); return; }
      const q = e.target.closest('[data-qty]');
      if (q) { e.preventDefault(); const inp = $('input[name="quantity"]', form); inp.value = Math.max(1, Math.min(99, (+inp.value || 1) + +q.dataset.qty)); return; }
      const t = e.target.closest('[data-thumb]');
      if (t && mainImg) {
        e.preventDefault();
        $$('[data-thumb]', root).forEach((x) => x.setAttribute('aria-pressed', String(x === t)));
        if (t.dataset.src) {
          mainImg.style.opacity = 0;
          setTimeout(() => { mainImg.removeAttribute('srcset'); mainImg.src = t.dataset.src; mainImg.style.transform = ''; mainImg.style.opacity = 1; }, 180);
        } else {
          const V = [{ s: 1, o: '50% 50%' }, { s: 2.4, o: '20% 55%' }, { s: 2.2, o: '50% 92%' }, { s: 2.6, o: '30% 10%' }][+t.dataset.view || 0];
          mainImg.style.transformOrigin = V.o; mainImg.style.transform = `scale(${V.s})`;
        }
      }
    });

    function applySize(size) {
      const si = names.indexOf(norm(T.sizeOption || 'Maat'));
      const vals = (i) => [...new Set(data.variants.map((v) => v.options[i]))];
      let ok = false;
      if (si > -1) { const m = vals(si).find((x) => String(x).trim().toUpperCase() === String(size).trim().toUpperCase()); if (m) { sel[si] = m; ok = true; } }
      update(true);
      return ok;
    }
    root.applySize = applySize;
    const p = new URLSearchParams(window.location.search);
    if (p.get('size')) applySize(p.get('size'));

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (btn.disabled) return;
      btn.setAttribute('aria-busy', 'true');
      try {
        const r = await fetch(R.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(form) });
        const res = await r.json();
        if (!r.ok) { toast(res.description || res.message || 'Toevoegen lukte niet.'); return; }
        await refreshCart();
        fly(mainImg, () => openCart());
      } catch (err) {
        form.submit();
      } finally { btn.removeAttribute('aria-busy'); }
    });
    update(false);
  }
  $$('[data-product]').forEach(initProduct);

  function fly(src, done) {
    const target = $('[data-open-cart]');
    if (!window.gsap || !src || !target || matchMedia('(prefers-reduced-motion: reduce)').matches) { done(); return; }
    const r = src.getBoundingClientRect(), t = target.getBoundingClientRect();
    const f = document.createElement('img'); f.src = src.currentSrc || src.src; f.alt = '';
    Object.assign(f.style, { position: 'fixed', zIndex: 90, width: Math.min(220, r.width) + 'px', left: r.left + r.width / 2 - Math.min(220, r.width) / 2 + 'px', top: r.top + r.height / 2 - 70 + 'px', pointerEvents: 'none' });
    document.body.appendChild(f);
    window.gsap.to(f, { x: t.left + t.width / 2 - (r.left + r.width / 2), y: t.top - (r.top + r.height / 2) + 50, scale: 0.12, rotation: -18, duration: 0.85, ease: 'power2.in', onComplete: () => { f.remove(); done(); } });
  }

  /* ---------- size finder ---------- */
  $$('[data-size-finder]').forEach((root) => {
    const SIZES = ['S', 'M', 'L', 'XL'];
    const L = (root.dataset.limits || '63,72,82,92,102').split(',').map(Number);
    const u = $('[data-under]', root), o = $('[data-over]', root), out = $('[data-size]', root), note = $('[data-note]', root), use = $('[data-use]', root);
    const cm = (n) => (Math.round(n * 10) / 10).toString().replace('.', ',');
    function calc() {
      const a = parseFloat(String(u.value).replace(',', '.')), b = parseFloat(String(o.value).replace(',', '.'));
      if (!(a > 0 && b > 0)) { out.textContent = '—'; note.textContent = 'Vul allebei je maten in.'; return null; }
      if (a < L[0] || a >= L[4] + 1) { out.textContent = '—'; note.textContent = `Onze maten passen bij een onderborst van ${L[0]} tot en met ${L[4]} cm. Meet je onderborst nog eens.`; return null; }
      let i = SIZES.findIndex((s, n) => a < L[n + 1] + 1);
      if (i < 0) i = SIZES.length - 1;
      const d = b - a, up = d > 22;
      if (up && i === SIZES.length - 1) { out.textContent = 'XL'; note.textContent = `Onderborst ${cm(a)} cm, verschil van ${cm(d)} cm. XL is onze grootste maat.`; return SIZES[i]; }
      if (up) i++;
      out.textContent = SIZES[i];
      note.textContent = up ? `Onderborst ${cm(a)} cm. Bij een verschil van ${cm(d)} cm kies je een maat groter.` : `Onderborst ${cm(a)} cm, verschil van ${cm(d)} cm.`;
      return SIZES[i];
    }
    [u, o].forEach((x) => x.addEventListener('input', calc));
    use.addEventListener('click', () => {
      const r = calc(); if (!r) return;
      const prod = $('[data-product]');
      if (prod && prod.applySize) {
        const ok = prod.applySize(r);
        go(prod); toast(ok ? `Maat ${r} staat klaar` : `Jouw maat is ${r}`);
      } else if (use.dataset.url) {
        window.location.href = `${use.dataset.url}?size=${r}`;
      } else toast(`Jouw maat is ${r}`);
    });
    calc();
  });

  /* ---------- collection sort ---------- */
  $$('[data-sort]').forEach((s) => s.addEventListener('change', () => {
    const u = new URL(window.location.href); u.searchParams.set('sort_by', s.value); window.location.href = u.toString();
  }));

  /* ---------- motion ---------- */
  const html = document.documentElement;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const anim = T.animations && window.gsap && window.ScrollTrigger && !reduce && !design;
  if (!anim) { html.classList.remove('js-anim'); html.classList.add('no-anim'); return; }
  const gsap = window.gsap, ST = window.ScrollTrigger;
  gsap.registerPlugin(ST);

  if (T.smoothScroll && window.Lenis) {
    try {
      lenis = new window.Lenis({ lerp: 0.085 });
      lenis.on('scroll', ST.update);
      gsap.ticker.add((t) => lenis.raf(t * 1000));
      gsap.ticker.lagSmoothing(0);
    } catch (e) { lenis = null; }
  }

  // hero
  $$('.hero').forEach((hero) => {
    const tl = gsap.timeline({ defaults: { ease: 'power4.out' } });
    tl.from($$('h1 .ln > span', hero), { yPercent: 110, duration: 1.1, stagger: 0.09 })
      .from($$('.kicker, .sub, .ctas, .trust', hero), { y: 24, opacity: 0, duration: 0.9, stagger: 0.07 }, '-=.8')
      .from($$('.bra-tilt img', hero), { y: -120, opacity: 0, scale: 0.8, rotation: -6, duration: 1.3, ease: 'elastic.out(1,.55)' }, 0.15)
      .from($$('.badge', hero), { scale: 0, opacity: 0, duration: 0.7, stagger: 0.12, ease: 'back.out(2)' }, '-=.7')
      .from($$('.sticker', hero), { scale: 0, rotation: -90, duration: 0.9, ease: 'back.out(1.6)' }, '-=.6')
      .from($$('.wordmark', hero), { yPercent: 30, opacity: 0, duration: 1.6 }, 0);
    const tilt = $('.bra-tilt', hero), wm = $('.wordmark', hero);
    if (tilt) gsap.to(tilt, { yPercent: 18, scale: 0.9, ease: 'none', scrollTrigger: { trigger: hero, start: 'top top', end: 'bottom top', scrub: true } });
    if (wm) gsap.to(wm, { xPercent: -12, ease: 'none', scrollTrigger: { trigger: hero, start: 'top top', end: 'bottom top', scrub: true } });
  });

  // pinned feature story
  $$('.story').forEach((story) => {
    const W = $$('.word', story), C = $$('.co', story), prod = $('.prod', story), pimg = $('.prod img', story), end = $('.end', story);
    const prog = $('[data-prog]', story), step = $('[data-step]', story);
    if (!prod) return;
    const mm = gsap.matchMedia();
    mm.add({ d: '(min-width:761px)', m: '(max-width:760px)' }, (ctx) => {
      const desk = ctx.conditions.d;
      gsap.set(prod, { xPercent: -50, yPercent: -50, x: 0, y: 0 });
      const n = Math.max(1, W.length), per = Math.ceil(C.length / n), seg = 2.1;
      const total = 0.3 + n * seg + 2.4;
      const s = gsap.timeline({
        defaults: { ease: 'none' },
        scrollTrigger: {
          trigger: story, start: 'top top', end: '+=' + (100 * (n + 1)) + '%', pin: true, scrub: 1, anticipatePin: 1,
          onUpdate: (x) => {
            if (prog) prog.style.transform = `scaleX(${x.progress})`;
            if (step) step.textContent = String(Math.min(n, 1 + Math.floor(x.progress * n))).padStart(2, '0') + ' / ' + String(n).padStart(2, '0');
          }
        }
      });
      s.fromTo(prod, { scale: 0.55, rotation: -8, yPercent: -30 }, { scale: desk ? 0.78 : 0.95, rotation: 0, yPercent: -50, duration: 1.6, ease: 'power2.out' }, 0);
      W.forEach((w, i) => {
        const st = 0.3 + i * seg;
        s.fromTo(w, { yPercent: 60, opacity: 0 }, { yPercent: 0, opacity: 1, duration: 0.8 }, st);
        if (pimg) s.to(pimg, { rotationY: i % 2 ? -14 : 14, duration: seg, ease: 'sine.inOut' }, st + 0.4);
        C.slice(i * per, i * per + per).forEach((c, k) => s.to(c, { opacity: 1, duration: 0.4 }, st + 0.7 + k * 0.4));
        if (i < W.length - 1) s.to(w, { yPercent: -60, opacity: 0, duration: 0.7 }, st + 1.9);
      });
      const fin = 0.3 + n * seg;
      if (pimg) s.to(pimg, { rotationY: 0, duration: 0.8 }, fin - 0.6);
      if (C.length) s.to(C, { opacity: 0, duration: 0.5 }, fin);
      if (W.length) s.to(W[W.length - 1], { opacity: 0, yPercent: -40, duration: 0.7 }, fin + 0.2);
      s.to(prod, { scale: desk ? 0.5 : 0.7, yPercent: -78, duration: 1.2, ease: 'power2.inOut' }, fin + 0.2);
      if (end) s.fromTo(end, { autoAlpha: 0, y: 40 }, { autoAlpha: 1, y: 0, duration: 0.8 }, fin + 0.8);
      s.to({}, { duration: Math.max(0.2, total - (fin + 1.6)) });
    });
  });

  // reveals
  $$('.reveal').forEach((el) => gsap.from(el, { y: 60, opacity: 0, duration: 1.1, ease: 'power3.out', scrollTrigger: { trigger: el, start: 'top 90%', once: true } }));
  $$('.pdp').forEach((p) => {
    gsap.from($$('.info > *', p), { y: 40, opacity: 0, duration: 0.9, stagger: 0.06, ease: 'power3.out', scrollTrigger: { trigger: p, start: 'top 85%', once: true } });
    gsap.from($$('.gallery', p), { y: 60, opacity: 0, scale: 0.97, duration: 1.2, ease: 'power3.out', scrollTrigger: { trigger: p, start: 'top 90%', once: true } });
  });
  $$('.mq').forEach((m) => gsap.fromTo(m, { xPercent: 0 }, { xPercent: -35, ease: 'none', scrollTrigger: { trigger: m.parentElement, start: 'top bottom', end: 'bottom top', scrub: 0.5 } }));
  $$('.finder .box').forEach((b) => gsap.from(b, { y: 80, scale: 0.96, opacity: 0, duration: 1.2, ease: 'power3.out', scrollTrigger: { trigger: b, start: 'top 88%', once: true } }));
  $$('.grid .pcard').forEach((c, i) => gsap.from(c, { y: 40, opacity: 0, duration: 0.9, delay: (i % 4) * 0.06, ease: 'power3.out', scrollTrigger: { trigger: c, start: 'top 92%', once: true } }));
  window.addEventListener('load', () => ST.refresh());
})();
